import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAddDeviceRequest, IAxiosRetryConfig, IDeviceData } from '../../../entity/interface/iDevices';
import { IDeviceRepository } from '../../repositories/interfaces/iDeviceRepository';

export interface IAddDeviceUseCase {
    execute(
        username: string,
        apiKey: string,
        payload: IAddDeviceRequest,
        token: string,
        identityToken: string,
        axiosRetryConfig: IAxiosRetryConfig
    ): Promise<IDeviceData | false>;
}

export class AddDeviceUseCase implements IAddDeviceUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get addDeviceRepository(): IDeviceRepository {
        return container.resolve<IDeviceRepository>(DI.REPOSITORIES.IDeviceRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        apiKey: string,
        payload: IAddDeviceRequest,
        token: string,
        identityToken: string,
        axiosRetryConfig: IAxiosRetryConfig
    ): Promise<IDeviceData | false> {
        const response = await this.addDeviceRepository.addDevice(
            username,
            apiKey,
            payload,
            token,
            identityToken,
            axiosRetryConfig
        );
        if (response.data) {
            return {
                ...response.data,
                playReadyLicenceUrl: response?.data?.playReadyLicenceUrl?.replace(/^http:\/\//i, 'https://'),
                widevineLicenceUrl: response?.data?.widevineLicenceUrl?.replace(/^http:\/\//i, 'https://'),
            };
        }
        return false;
    }
}
